import React from 'react'

export default function AboutFinwizz() {
    return (
        <div id='/about'>
            <div className="container-fluid">
                <div className="row">
                    <h3 className='text-center mt-5' style={{ color: "#dd0c2c" }}>About Make My Property</h3>
                    <div className='line'></div>

                    <div>
                        <p className='mx-5 justify-content-center my-5'>MakeMyProperty is more than a real estate agency; we are a community of passionate professionals united by a common goal – to simplify and enrich the process of buying and selling properties. Our team brings together expertise in real estate, market trends, and client service to provide you with a comprehensive and unparalleled experience.
                            </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
